import autoComplete from '../features/auto-complete';
// Docs found here https://github.com/Pixabay/JavaScript-autoComplete

// Factory pattern for creating reuseable components.
const NavSearch = {
  create(identifier) {
    const self = this;
    const componentSelector = '.nav-search--' + identifier;
    const component = $(componentSelector);
    const inputSelector = componentSelector + ' .nav-search__input';
    const menuClass = 'nav-search__menu nav-search__menu--' + identifier;
    const dataFromMarkup = component.data();
    $(inputSelector).on('focus', (e) => {
      this.adjustMenuHeight(e);
    });

    new autoComplete({
      selector: inputSelector,
      minChars: 3,
      menuClass: menuClass,
      source: (term, suggestions) => { self.sourceData(dataFromMarkup, term, suggestions); },
      renderItem: (item, search) => {
         const label = item.display_name || `${item.name}, ${item.state}`;
        return `<a rel="nofollow" class="autocomplete-suggestion nav-search__menu-item"
                   href="${self.buildMenuLink(dataFromMarkup, item)}">${label}</a>`;
      },
      onSelect: (e, term, item) => {
        window.location.href = item.href;
      }
    });
  },

  buildMenuLink(dataFromMarkup, item) {
    const possibleLocale = dataFromMarkup.locale ? `${dataFromMarkup.locale}-` : '';
    // short_name_unique means locale, short_name means subject
    const href = item.short_name_unique ?
      `/tutoring-${item.short_name_unique}` : `/${possibleLocale}${item.short_name}-tutoring`;
    return href;
  },

  sourceData(dataFromMarkup, term, suggestions) {
    term = term.toLowerCase();
    // TODO, test native fetch compatibility on browserstack.
    // return fetch(`${this.props.apiEndpoint}/lookup?query=${term}`)
    //   .then((response) => response.json())
    //   .then((json) => {
    //     return { options: json };
    //   });

    $.getJSON(`/${dataFromMarkup.apiEndpoint}/lookup`,
      { query: term },
      (data) => {
        $('.nav-search__menu').hide();
        suggestions(data);
      }
    );
  },

  adjustMenuHeight: function(e) {
    const parentMenu = $(e.target).closest('.site-nav__menu');
    const label = parentMenu.attr('id').replace('menu-', '');
    const height = parentMenu.height();
    $('.nav-search__menu--'+label).css({maxHeight: (height-100)});
  }
};

// Initialize upon document load
$(function() {
  NavSearch.create('locations');
  NavSearch.create('test-prep');
  NavSearch.create('academic-tutoring');
});



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/components/nav-search.js
 **/